import ChatTelemetryIpcRouter, { type ChatTelemetryIpcRouterType } from '@shared/ipc/routers/ChatTelemetryIpc.router'
import type { ChatTurnTelemetryEvent } from '@shared/chat-telemetry/turn-events'

class ChatTelemetryIpcRenderer extends ChatTelemetryIpcRouter implements ChatTelemetryIpcRouterType {
  async record(event: ChatTurnTelemetryEvent): Promise<void> {
    await this.exec('record', event)
  }
}

export default new ChatTelemetryIpcRenderer()
